<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite"
          >新增</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="save"
          :disabled="Status === 2 || !canWrite"
          >保存</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          :disabled="!isSave || Status === 2 || !canWrite"
          @click="handleDelete"
          >删除</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="reView"
          v-if="Status !== 2"
          :disabled="!isSave || !canReview"
          >审核</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="cancelReView"
          v-if="Status === 2"
          :disabled="!isSave || !canReview"
          >弃审</el-button
        >
      </div>
      <el-form
        :model="data"
        ref="form"
        :inline="true"
        :line-form="true"
        label-width="100px"
        status-icon
      >
      <el-row style="margin-top: 18px">
          <el-form-item label="账面日期:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required label-width="100px">
            <span
              style="display: inline-block; width: 180px"
              v-if="Mode == 0"
              class="detail-span"
              >{{ data.ProfitLossNo }}</span
            >
            <el-input
              style="width: 180px"
              v-else
              v-model="data.ProfitLossNo"
              placeholder="请输入单据编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="出库类别:" required label-width="100px">
            <type-outselect
              ref="typeOutSelect"
              :disabledStatus="Status"
              v-model="data.OutClassId"
              style="width: 180px"
            />
          </el-form-item>
          <el-form-item label="入库类别:" required label-width="100px">
            <type-inselect
              ref="typeInSelect"
              :disabledStatus="Status"
              v-model="data.InClassId"
              style="width: 180px"
            />
          </el-form-item>
          <el-form-item label="仓库:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.WarehouseName
            }}</span>
            <el-select v-else style="width: 180px" v-model="data.WarehouseId">
              <el-option
                v-for="item in warehouseList"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车间:" label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.WorkShopName }}</span>
            <v-select v-else style="width: 180px" ref="typeSelect" v-model="data.WorkshopId" />
          </el-form-item>
          <el-form-item label="经手人:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.EmpName"
              v-model="data.EmpId"
              @click="openEmp"
              style="width: 180px"
            />
          </el-form-item>
          <el-form-item label="制单人:" label-width="100px">
            <span class="span" style="width: 180px !important">{{
              data.MarkEmpName
            }}</span>
          </el-form-item>
          <el-form-item label="溢损类型:" required label-width="100px">
            <span class="not-edit" v-if="Status === 2">{{
              data.TypeName
            }}</span>
            <el-select v-model="data.Type">
              <el-option :value="0" label="损耗"></el-option>
              <el-option :value="1" label="溢出"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
          <el-form-item label="备注:" label-width="100px">
            <el-input
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              :disabled="Status === 2"
              style="width: 600px"
            />
          </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
        :row-class-name="tableRowClassName"
        stripe
        style="margin-top: 18px"
        @row-click="add"
        v-keymove="newLine"
      >
        <insert-row @on-insert="onInsert" />
        <el-table-column min-width="160" align="center" label="备注">
          <template slot-scope="{ row }">
            <span v-if="Status === 2">{{ row.Remark }}</span>
            <el-input
              v-else
              v-model="row.Remark"
              @change="editT(row)"
              placeholder="请输入备注"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="条形码"
          prop="ProductNo"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <vue-barcode
              v-if="row.ProductNo"
              :value="row.ProductNo"
              height="20"
              fontSize="10"
            ></vue-barcode>
          </template>
        </el-table-column> -->
        <el-table-column
          label="存货名称"
          prop="ProductName"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2 || !data.WarehouseId">{{
              row.ProductName
            }}</span>
            <account-select
              v-else
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="listTotal"
              @inputText="inputText($event, row)"
              @click.native="resetFun"
              @currentPage="currentPage($event, row)"
              :pageType="true"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="存货编码"
          prop="ProductNo"
          align="center"
          min-width="160"
        >
        </el-table-column>
        <el-table-column
          label="规格型号"
          prop="ProductSpec"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="属性"
          prop="PropertyId"
          align="center"
          min-width="100"
          key="table1_6"
        >
          <template slot-scope="{ row }">
            <el-select
              v-if="row.UseProcess && Status !== 2"
              v-model="row.PropertyId"
              @change="changeProperty($event, row)"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.PropertyId"
                :label="item.PropertyName"
                :value="item.PropertyId"
              ></el-option>
            </el-select>
            <span class="not-edit" v-else>{{
              row.UseProcess ? row.PropertyName : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="颜色"
          prop="ColorId"
          align="center"
          min-width="100"
          key="table1_7"
        >
          <template slot-scope="{ row }">
            <el-select
              v-if="row.UseColor && Status !== 2"
              v-model="row.ColorId"
              @change="changeColor($event, row)"
            >
              <el-option
                v-for="item in row.Colors"
                :key="item.ColorId"
                :label="item.ColorName"
                :value="item.ColorId"
                :disabled="item.Status==0"
              ></el-option>
            </el-select>
            <span class="not-edit" v-else>{{
              row.UseColor ? row.ColorName : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="计量单位" min-width="120px">
          <template slot-scope="{ row, $index }">
            <el-select
              v-if="row.Units && row.Units.length > 0"
              v-model="row.UnitId"
              :disabled="Status === 2"
            >
              <el-option
                v-for="item in row.Units"
                :key="item.UnitId"
                :value="item.UnitId"
                :label="item.UnitName"
                @click.native="compareSaUnit(item, row, $index)"
              ></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
          <!--  -->
        </el-table-column>
        <el-table-column
          label="仓库现存量"
          prop="ExistQuantity"
          align="center"
          min-width="100"
        >
        <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toThousands(row.ExistQuantity)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="溢损数量"
          prop="Quantity"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{
              $commonJs.toThousands(row.Quantity)
            }}</span>
            <el-input
              type="text"
              v-else
              v-model="row.Quantity"
              @change="changeQuantity($event, row, $index)"
            ></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="属性"
          prop="DiffQuantity"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          label="颜色"
          prop="DiffQuantity"
          align="center"
          min-width="100"
        >
        </el-table-column> -->
        <!-- <el-table-column align="center" v-if="tableColorShow"  label="颜色" min-width="120px">
              <template slot-scope="{ row, $index }">
                <el-select
                  v-if="row.UseColor && !ReviewStatus"
                  v-model="row.ColorId"
                  @change="changeColor(row, $index)"
                >
                  <el-option
                    v-for="item in row.Colors"
                    :key="item.ColorId"
                    :value="item.ColorId"
                    :label="item.ColorName"
                  />
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column> -->
        <el-table-column
          label="单价"
          prop="Price"
          align="center"
          min-width="100"
          key="table1_10"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
            <el-input
              type="text"
              v-else
              @change="changePrice($event, row)"
              v-model="row.Price"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="溢损金额"
          prop="Amount"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
        <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toThousands(row.Amount)
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="计量单位2" min-width="120px">
          <template slot-scope="{ row, $index }">
            <el-select
              v-if="row.Units && row.Units.length > 0"
              v-model="row.UnitId2"
              :disabled="Status === 2"
            >
              <el-option
                v-for="item in row.Units"
                :key="item.UnitId"
                :value="item.UnitId"
                :label="item.UnitName"
                @click.native="compareUnitId(item, row, $index)"
              ></el-option>
            </el-select>
            <span v-else-if="row.UnitType == 0"></span>
            <span v-else>{{ row.UnitName2 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="仓库现存量2"
          prop="ExistQuantity2"
          align="center"
          min-width="100"
        >
        <template slot-scope="{ row }">
            <span class="not-edit" >{{
              $commonJs.toThousands(row.ExistQuantity2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="溢损数量2"
          prop="Quantity2"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row, $index }">
            <span class="not-edit" v-if="Status === 2">{{
              $commonJs.toThousands(row.InventoryQuantity2)
            }}</span>
            <el-input
              v-else
              v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)"
              type="text"
              v-model="row.InventoryQuantity2"
              @change="changeQuantity2($event, row, $index)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="单价2"
          prop="Price2"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
            <el-input
              v-else
              v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)"
              type="text"
              v-model="row.Price2"
              @change="changePrice2($event, row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="换算率">
          <template slot-scope="{ row, $index }">
            <span
              v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1"
              >{{ row.Rate }}</span
            >
            <span v-else-if="row.UnitType == 0"></span>
            <el-input
              v-else
              type="text"
              v-model="row.Rate"
              @change="RateChange($event, row, $index)"
            ></el-input>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              @click="del(row, $index)"
              :disabled="Status === 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>


      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <edit-dialog ref="editDialog" @saved="saved"></edit-dialog>
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import editDialog from "@/components/business/stock/inventoryoverflow/editDialog";
import accountSelect from "@/components/business/stock/select";
import empDialog from "@/components/personnel/result/record/listDialog";
import vSelect from "@/components/business/stock/productionpicking/vSelect";
import optionMixins from "@/mixins/option";
import typeOutselect from "./outSelect";
import typeInselect from "./inSelect";

export default {
  mixins: [optionMixins],
  name: "editworkshopprofit",
  components: {
    editDialog,
    accountSelect,
    VueBarcode,
    empDialog,
    typeOutselect,
    typeInselect,
    vSelect,
  },
  data() {
    return {
      api: require("@/api/pr/workshopprofit").default,
      pdApi: require("@/api/ba/product").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      code_api: require("@/api/sy/serialCode").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      propertyApi: require("@/api/ba/property").default,
      inDocApi: require("@/api/stock/stInDoc").default,
      outDocApi: require("@/api/stock/stOutDoc").default,
      propertyList: [],
      Mode: 0,
      warehouseList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      tableColorShow: true,
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      Status: 0,
      isSave: false,
      data: {
        ProfitLossId:0,
        ProfitLossNo:null,
        OutClassId: 0,
        InClassId: 0,
        DocType: 0,
        DocDate: this.$commonJs.getToday(),
        WorkshopId: 0,
        WorkShopName: "",
        WarehouseId: null,
        EmpName: "",
        EmpId: 0,
        MarkEmpName: "",
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewTime: "",
        Remark: "",
        Type: 0,
        TypeName:null
      },
      date: [],
      tableData: [
        {
          T: 0,
          ProfitLossDtsId: 0,
          ProductId: "",
          ProductName: "",
          ProductNo: "",
          ProductSpec: "",
          Quantity: null,
          InventoryQuantity: null,
          DiffQuantity: null,
          Price: null,
          Price2: null,
          Amount: null,
          InventoryAmount: null,
          DiffAmount: null,
          Quantity2: null,
          InventoryQuantity2: null,
          DiffQuantity2: null,
          Rate: null,
          UnitName: "",
          UnitName2: "",
          UnitId: "",
          UnitId2: "",
          Units: [],
          ColorId: null,
          ColorName: "",
          Colors: [],
          PropertyId: null,
          PropertyName: "",
          Remark: "",
        },
      ],
      viewType: "create",
      delTableData: [],
      isUseProcess: true,
      isUseColor: true,
      keepData: [],
    };
  },
  computed: {
    btnDisabled() {
      return this.data.WarehouseId == null ? true : false;
    },
    canPrice() {
      return this.$permission.canPrice("/business/stock/inventoryoverflow");
    },
    canWrite() {
      return this.$permission.canWrite("/business/stock/inventoryoverflow");
    },
    canReview() {
      return this.$permission.canReview("/business/stock/inventoryoverflow");
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.viewType = this.$route.params.type;

    if (this.$route.params.type === "create") {
      this.getPreviewNo();
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },

  methods: {
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type);
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        ProfitLossDtsId: 0,
        ProductId: "",
        ProfitLossId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        Quantity: 0,
        InventoryQuantity: 0,
        DiffQuantity: 0,
        Price: 0,
        Amount: 0,
        InventoryAmount: 0,
        DiffAmount: 0,
        Quantity2: 0,
        InventoryQuantity2: 0,
        DiffQuantity2: 0,
        Rate: "",
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableData.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableData));
      this.tableData = [];
      this.$nextTick(() => {
        this.tableData = copy;
      });
      console.log("this.tableData", this.tableData);
    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("溢损单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.ProfitLossNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取溢损单编号失败");
        }
      });
    },
    init() {
      this.propertyApi
        .list({
          Status: 1,
        })
        .then((res) => {
          if (res.Code === 0) {
            this.propertyList = res.Data;
          }
        });

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });

      this.warehouseApi.list({ }).then((res) => {
        if (res.Code === 0) {
          this.warehouseList = res.Data.map((item) => {
            this.data.WarehouseId = res.Data[0].WarehouseId;
            this.data.WarehouseName = res.Data[0].WarehouseName;
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });

      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "库存溢损单";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.data.DocType = SourceTypeId;
        }
      });

      this.callOptionApi();
    },
    editInit(data, type = "edit") {
      this.viewType = "edit";
      this.isSave = true;
      let {
        ProfitLossModelDts,
        ProfitLossNo,
        OutClassId,
        InClassId,
        ProfitLossId,
        DocType,
        DocDate,
        WorkshopId,
        WorkShopName,
        WarehouseId,
        EmpName,
        EmpId,
        Status,
        MarkEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewTime,
        Remark,
        WarehouseName,
        Type,
      } = data;

      this.data = {
        ProfitLossNo,
        OutClassId,
        InClassId,
        ProfitLossId,
        DocType,
        DocDate,
        WorkshopId,
        WorkShopName,
        WarehouseId,
        EmpName,
        EmpId,
        MarkEmpName,
        MakeEmpId,
        ReviewEmpName,
        ReviewEmpId,
        ReviewTime,
        Remark,
        WarehouseName,
        Type
      };

      this.Status = Status;

      ProfitLossModelDts.forEach((item, index) => {
        item.T = null;
        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null;
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null;

        // if (item.Units.length === 0 || item.Units == null) {
        //   item.UnitType = 0;
        // } else {
        //   item.UnitType = 1;
        //   let UnitItem = item.Units.filter((v) => {
        //     return item.UnitId === v.UnitId;
        //   })[0];
        //   item.IsMain = UnitItem.IsMain;
        //   item.Units.forEach((v) => {
        //     if (v.ChangeType == 1) item.ChangeType = v.ChangeType;
        //   });
        // }
        // if (type == "keep") {
        //   item.ChangeType = this.keepData[index].ChangeType;
        // }
        // this.changeQuantity(item.InventoryQuantity ,item);
      });

      this.tableData = ProfitLossModelDts;
    },
    flattenArray(arr) {
      let result = [];
      
      function flatten(obj, parent = {}) {
          for (let key in obj) {
              if (obj.hasOwnProperty(key)) {
                  if (Array.isArray(obj[key])) {
                      obj[key].forEach(item => flatten(item, { ...parent }));
                      return; // To avoid pushing parent multiple times
                  } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                      flatten(obj[key], { ...parent });
                  } else {
                      parent[key] = obj[key];
                  }
              }
          }
          result.push(parent);
      }
    
      arr.forEach(item => flatten(item));
      return result;
    },
    changeProperty(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;
      row.PropertyId = item.PropertyId;
      this.getReferenceCost(row);
    },
    changeColor(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }
      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
      row.ColorId = item.ColorId;
      this.getReferenceCost(row);
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    changeUnitId2(val, row) {
      this.editT(row);

      let item = row.Units2.filter((item) => {
        return item.UnitId === val;
      })[0];

      row.UnitId2 = item.UnitId;
      row.UnitName2 = item.UnitName;

      row.Rate2 = item.Rate;
      row.ChangeType2 = item.ChangeType;

      row.Rate = row.Rate1 / row.Rate2;
    },

    onSelect(e, row) {
      console.log(e, "e");

      this.editT(row);

      row.Units = [];

      row.ColorId = null;
      row.PropertyId = null;

      row.UnitName = "";
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.Units = e.Units;
      row.Colors = e.Colors;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;

      row.UnitId = e.SkUnitId;
      row.ChangeType = 0;
      row.UnitType = 0;
      
      //选单带出颜色 如果有颜色就显示
      // let _colorShow=this.tableList.find(item=>item.UseColor==true)
      //    if(_colorShow){
      //    this.tableColorShow=true
      //    }else{
      //     this.tableColorShow=false
      //     }
      if (e.Units.length === 0) {
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      } else {
        console.log(row.UnitId, "row.UnitId");
        row.UnitType = 1;
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        if(row.UnitId){
          let index = this.getUnitIndex(3, e.Units, row.UnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = assistData.Rate.toFixed(5);
            row.Quantity2 = this.getQuantity(row.Quantity / Number(row.Rate));
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = data.Rate.toFixed(5);
          }
          row.UnitId2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        }else{
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for(let i = 0; i < untiLength; ++i){
            if(e.Units[i].IsMain){
              mainData.push(e.Units[i])
            }else{
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }
        
      }

      // this.api.referenceCost({WarehouseId: this.data.WarehouseId, ProfitLossId: row.ProfitLossId}).then(res => {
      //   if(res.Code === 0){
      //     console.log(res.Data,'res.Data')
      //     row.Price = res.Data.ReferenceCost > 0 ? res.Data.ReferenceCost : 0
      //     row.Quantity = res.Data.ExistQuantity;
      //     row.Amount = parseFloat((row.Quantity * row.Price).toFixed(2))
      //   }
      // })
      this.getReferenceCost(row);
    },

    getReferenceCost(data) {
      let o = {
        ProductId: data.ProductId,
        ProfitLossId: data.ProfitLossId,
        WarehouseId: this.data.WarehouseId,
        ColorId: data.ColorId,
        PropertyId: data.PropertyId,
      };
      o = this.$commonJs.obj.removeNullKey(o);
      this.api.referenceCost(o).then((res) => {
        if (res.Code === 0) {
          console.log(res.Data, "res.Data");
          data.Price = res.Data.ReferenceCost > 0 ? res.Data.ReferenceCost : 0;
          data.Quantity = res.Data.ExistQuantity;
          data.Amount = parseFloat((data.Quantity * data.Price).toFixed(2));
        }
      });
    },

    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      this.tableData[index].IsMain = data.IsMain;
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        num = row.InventoryQuantity;
        row.InventoryQuantity = row.InventoryQuantity2;
        row.InventoryQuantity2 = num;

        num = row.DiffQuantity;
        row.DiffQuantity = row.DiffQuantity2;
        row.DiffQuantity2 = num;

        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex);
          // row.ChangeType1 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeRightUnitId(index, findIndex, data.Rate);
          // row.ChangeType1 = data.ChangeType;
          if (lastIsMain) {
            row.InventoryQuantity2 = row.InventoryQuantity;
          }
          // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
          row.InventoryQuantity = this.getQuantity(
            row.InventoryQuantity2 / Number(data.Rate)
          );
        }
      }
      this.changeQuantity(
        this.tableData[index].InventoryQuantity,
        row,
        index,
        1
      );

      let val = this.setNumber(
        Math.abs(row.InventoryAmount / row.InventoryQuantity)
      );
      row.Price = this.getPrice(val);

      val = this.setNumber(
        Math.abs(row.InventoryAmount / row.InventoryQuantity2)
      );
      row.Price2 = this.getPrice(val);
    },
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId2 =
        this.tableData[index].Units[findIndex].UnitId;
      this.tableData[index].UnitName2 =
        this.tableData[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableData[index].Rate = Rate;
      }
    },
    changeQuantity(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      this.editT(row);

      data = this.setNumber(data);
      row.InventoryQuantity = parseFloat(this.getQuantity(data));

      //盈亏数量
      row.DiffQuantity = parseFloat(
        this.getQuantity(row.InventoryQuantity - row.Quantity)
      );

      if (row.T == 3) this.tableData[index].T = 1;
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(2);
          row.InventoryQuantity2 = this.getQuantity(
            row.InventoryQuantity / Number(row.Rate)
          );

          row.DiffQuantity2 = parseFloat(
            this.getQuantity(row.InventoryQuantity2 - row.Quantity2)
          );

          if (type === 0) {
            row.InventoryAmount = this.setAmount(
              row.Price,
              row.InventoryQuantity
            );
            if (row.Price !== 0) {
              row.Price2 = row.InventoryAmount / row.InventoryQuantity2;
            }
            row.DiffAmount = parseFloat(
              (row.DiffQuantity * row.Price).toFixed(2)
            );
          }
        } else {
          row.InventoryQuantity2 = this.getQuantity(data * Number(row.Rate));
          if (type === 0) {
            row.InventoryAmount = this.setAmount(
              row.Price,
              row.InventoryQuantity
            );
            row.DiffAmount = parseFloat(
              (row.DiffQuantity * row.Price).toFixed(2)
            );
          }
        }
      } else {
        row.InventoryQuantity2 = row.InventoryQuantity;
        row.Amount = this.setAmount(row.Price, row.InventoryQuantity);
      }
    },
    setAmount(p, q) {
      return parseFloat((p * q).toFixed(2));
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;

      this.editT(row);

      let lastIsMain = row.IsMain;
      if (data.IsMain) {
        this.tableData[index].IsMain = false;
      } else {
        this.tableData[index].IsMain = true;
      }
      let findIndex = 0;
      if (row.UnitId == row.UnitId2) {
        let num = 0;
        num = row.Quantity;
        row.Quantity = row.Quantity2;
        row.Quantity2 = num;

        num = row.InventoryQuantity;
        row.InventoryQuantity = row.InventoryQuantity2;
        row.InventoryQuantity2 = num;

        num = row.DiffQuantity;
        row.DiffQuantity = row.DiffQuantity2;
        row.DiffQuantity2 = num;

        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        }
      } else {
        if (this.tableData[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex);
          // row.ChangeType2 = data.ChangeType;
        } else {
          findIndex = this.getUnitIndex(1, this.tableData[index].Units);
          this.changeLeftUnitId(index, findIndex, data.Rate);
          // row.ChangeType2 = data.ChangeType;
          if (!lastIsMain) {
            row.InventoryQuantity = row.InventoryQuantity2;
          }
          // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
          row.InventoryQuantity2 = this.getQuantity(
            row.InventoryQuantity / Number(data.Rate)
          );
        }
      }

      this.changeQuantity2(
        this.tableData[index].InventoryQuantity2,
        row,
        index,
        1
      );

      let val = this.setNumber(
        Math.abs(row.InventoryAmount / row.InventoryQuantity)
      );
      row.Price = this.getPrice(val);

      val = this.setNumber(
        Math.abs(row.InventoryAmount / row.InventoryQuantity2)
      );
      row.Price2 = this.getPrice(val);
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableData[index].UnitId =
        this.tableData[index].Units[findIndex].UnitId;
      this.tableData[index].SaUnitName =
        this.tableData[index].Units[findIndex].UnitName;
      // this.tableData[index].ChangeType1 =
      //   this.tableData[index].Units[findIndex].ChangeType;

      if (Rate > 0) {
        this.tableData[index].Rate = Rate;
      }
    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      this.editT(row);
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      // if (this.data.MinusEntry) {
      //   row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
      //   row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
      // } else {
      //   row.Quantity = Math.abs(row.Quantity);
      //   row.Quantity2 = Math.abs(row.Quantity2);
      // }
      data = this.setNumber(data);
      row.InventoryQuantity2 = parseFloat(this.getQuantity(data));

      //盈亏数量
      row.DiffQuantity2 = parseFloat(
        this.getQuantity(row.InventoryQuantity2 - row.Quantity2)
      );

      // 盘点金额
      //row.InventoryAmount = parseFloat((row.InventoryQuantity2 * row.Price2).toFixed(2));

      // 盈亏金额
      row.DiffAmount2 = parseFloat((row.DiffQuantity2 * row.Price2).toFixed(2));

      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.InventoryQuantity != 0) {
          row.Rate = Math.abs(Number(data / row.InventoryQuantity)).toFixed(2);
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.InventoryAmount / data));
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2/换算率");
          // row.Quantity=Number(data/row.Rate).toFixed(2);
          // row.InventoryQuantity = this.getQuantity(data / row.Rate);
          if (row.InventoryQuantity === 0) {
            row.InventoryQuantity = this.getQuantity(data * row.Rate);
          } else {
            row.InventoryQuantity = this.getQuantity(data / row.Rate);
          }
          if (type === 0) {
            row.InventoryAmount = this.setAmount(
              row.Price2,
              row.InventoryQuantity2
            );
          }
        }
      } else {
        if (row.ChangeType == 1 && row.InventoryQuantity != 0) {
          console.log("row.InventoryQuantit", row.InventoryQuantity);
          console.log("data", data);

          row.Rate = Math.abs(Number(row.InventoryQuantity / data)).toFixed(2);
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.InventoryAmount / data));
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2*换算率");
          // row.Quantity=Number(data*row.Rate).toFixed(2);
          row.InventoryQuantity = this.getQuantity(data * row.Rate);
          if (type === 0) {
            row.InventoryAmount = this.setAmount(
              row.Price2,
              row.InventoryQuantity
            );
          }
        }
      }
    },
    changePrice(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      // row.Price = this.getPrice(val);
      // row.InventoryAmount = this.setAmount(row.Price, row.InventoryQuantity);
      // row.DiffAmount = parseFloat((row.DiffQuantity * row.Price).toFixed(2));
      // row.Amount = parseFloat((row.Quantity * row.Price).toFixed(2));

      // if (row.UnitId2 && row.InventoryQuantity2 !== 0) {
      //   row.Price2 = this.getPrice(
      //     row.InventoryAmount / row.InventoryQuantity2
      //   );
      // }

      row.Amount = parseFloat((row.Quantity * row.Price).toFixed(2));
    },
    changePrice2(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.Price2 = this.getPrice(val);
      row.DiffAmount = parseFloat((row.DiffQuantity * row.Price2).toFixed(2));
      row.Amount = parseFloat((row.Quantity * row.Price2).toFixed(2));

      row.InventoryAmount = this.setAmount(row.Price2, row.InventoryQuantity2);
      if (row.Quantity !== 0) {
        row.OutPrice = this.getPrice(
          row.InventoryAmount / row.InventoryQuantity
        );
      }
    },
    changeInventoryAmount(val, row) {
      this.editT(row);

      // if (this.data.MinusEntry) {
      //   val = val > 0 ? 0 - val : val;
      // } else {
      //   val = Math.abs(val);
      // }
      row.InventoryAmount = this.setNumber(val);

      if (row.InventoryQuantity !== 0) {
        row.Price = this.getPrice(
          Math.abs(row.InventoryAmount / row.InventoryQuantity)
        );
        this.changePrice2(row.Price, row);
      } else {
        this.$message({ type: "warning", message: "数量不能为0" });
        row.InventoryAmount = 0;
        return;
      }

      if (row.InventoryQuantity2 !== 0) {
        row.Price2 = this.getPrice(
          Math.abs(row.InventoryAmount / row.InventoryQuantity2)
        );
        this.changePrice2(row.Price2, row);
      } else {
        this.$message({ type: "warning", message: "数量2不能为0" });
        row.InventoryAmount = 0;
        return;
      }
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(2);
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(2);
        row.InventoryQuantity2 = this.getQuantity(
          row.InventoryQuantity / Number(data)
        );
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(2);
        row.InventoryQuantity = this.getQuantity(
          row.InventoryQuantity2 / Number(data)
        );
      }

      let val = this.setNumber(row.InventoryAmount / row.InventoryQuantity);
      row.Price = this.getPrice(val);

      val = this.setNumber(row.InventoryAmount / row.InventoryQuantity2);
      row.Price2 = this.getPrice(val);
    },
    resetFun() {
      if (!this.data.WarehouseId) {
        this.$message({ type: "warning", message: "请先选择仓库" });
        return;
      }
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({val, text1}, row) {
      this.pageParams.pageIndex = val;
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1}).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text, row) {
      row.ProductName = text;
      this.pdApi
        .list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1, })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    saved(data) {
      let o = {
        T: 0,
        ProfitLossId: 0,
        ProfitLossDtsId: 0,
        WarehouseId: "",
        WarehouseName: "",
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        Quantity: 0,
        InventoryQuantity: 0,
        DiffQuantity: 0,
        Price: 0,
        Amount: 0,
        InventoryAmount: 0,
        DiffAmount: 0,
        Quantity2: 0,
        InventoryQuantity2: 0,
        DiffQuantity2: 0,
        Rate: "",
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
      };

      o.ProductName = data.ProductName;
      o.ProductNo = data.ProductNo;
      o.ProductId = data.ProductId;
      o.ProductSpec = data.ProductSpec;
      o.Units = data.Units;

      if (data.Units.length !== 0) {
        let Units = data.Units.filter((item) => {
          return item.IsMain;
        });
        if (Units.length !== 0) {
          o.ChangeType = Units[0].ChangeType;
          o.Rate1 = Units[0].Rate;
          o.UnitId = Units[0].UnitId;
          o.UnitName = Units[0].UnitName;
        }

        o.Units2 = data.Units.filter((item) => {
          return !item.IsMain;
        });

        if (o.Units2.length !== 0) {
          o.UnitId2 = o.Units2[0].UnitId;
          o.UnitName2 = o.Units2[0].UnitName;

          o.Rate2 = o.Units2[0].Rate;
          o.ChangeType2 = o.Units2[0].ChangeType;
          o.Rate = o.Rate1 / o.Rate2;
        }
      } else {
        o.UnitId = data.SkUnitId;
        o.UnitName = data.SkUnitName;
        o.UnitId2 = data.SkUnitId;
        o.UnitName2 = data.SkUnitName;
        o.ChangeType = 0;
        o.ChangeType2 = 0;
        o.Rate = 1;
      }

      this.api
        .referenceCost({
          WarehouseId: this.data.WarehouseId,
          ProductId: o.ProductId,
        })
        .then((res) => {
          if (res.Code === 0) {
            o.Price = res.Data.ReferenceCost;
            o.Quantity = res.Data.ExistQuantity;
          }
        });

      this.tableData.push(o);
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          this.delTableData.push(row);
        }

        this.tableData.splice(index, 1);
        if (this.tableData.length === 0) {
          this.newLine();
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    newLine() {
      let o = {
        T: 0,
        ProfitLossId: 0,
        ProfitLossDtsId: 0,
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        Quantity: null,
        InventoryQuantity: null,
        DiffQuantity: null,
        Price: null,
        Price2: null,
        Amount: null,
        InventoryAmount: null,
        DiffAmount: null,
        Quantity2: null,
        InventoryQuantity2: null,
        DiffQuantity2: null,
        Rate: null,
        UnitName: "",
        UnitName2: "",
        UnitId: "",
        UnitId2: "",
        Units: [],
        Remark: "",
      };

      this.tableData.push(o);
    },
    add(row, column) {
      if (column.label === "操作" || this.Status === 2) {
        return;
      }
      if (row.index === this.tableData.length - 1) {
        this.newLine();
      }
    },
    getProducts(data) {
      console.log("🚀 ~ getProducts ~ data:", data)
      data = data.filter((item) => {
        return item.ProductName;
      });
      let ProfitLossModelDts = [];
      data.forEach((item) => {
        let {
          T,
          ProfitLossId,
          ProfitLossDtsId,
          ProductId,
          ProductName,
          ProductNo,
          ProductSpec,
          Quantity,
          InventoryQuantity,
          DiffQuantity,
          Price,
          Amount,
          InventoryAmount,
          DiffAmount,
          Quantity2,
          InventoryQuantity2,
          DiffQuantity2,
          Rate,
          UnitName,
          UnitName2,
          UnitId,
          UnitId2,
          Units,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          Colors,
          Price2,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          WorkshopId
        } = item;
        PropertyId = PropertyId ? PropertyId : 0;
        ColorId = ColorId ? ColorId : 0;
        let o = {
          T,
          ProfitLossId,
          ProfitLossDtsId,
          ProductId,
          ProductName,
          ProductNo,
          ProductSpec,
          Quantity,
          InventoryQuantity,
          DiffQuantity,
          Price,
          Amount,
          InventoryAmount,
          DiffAmount,
          Quantity2,
          InventoryQuantity2,
          DiffQuantity2,
          Rate,
          UnitName,
          UnitName2,
          UnitId,
          UnitId2,
          Units,
          PropertyId,
          PropertyName,
          ColorId,
          ColorName,
          Colors,
          Price2,
          ChangeType,
          Remark,
          UseColor,
          UseProcess,
          WorkshopId
        };

        ProfitLossModelDts.push(o);
      });

      return ProfitLossModelDts;
    },
    save(type = 0) {
      //验证表单是否填写
      let yanzheng = [
        "DocDate",
        "OutClassId",
        "InClassId",
        "WarehouseId",
        "ProfitLossNo",
        "EmpId",
      ];

      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: "warning", message: "表单未填写完整" });
          return;
        }
      }

      let ProfitLossModelDts = this.getProducts(this.tableData);

      ProfitLossModelDts = ProfitLossModelDts.concat(this.delTableData);
      this.keepData = ProfitLossModelDts;
      ProfitLossModelDts = ProfitLossModelDts.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });
      let ProductsLength = ProfitLossModelDts.length;
      for (let i = 0; i < ProductsLength; ++i) {
        if (ProfitLossModelDts[i].UseColor && ProfitLossModelDts[i].ColorId === 0) {
          this.$message.error(`存货${ProfitLossModelDts[i].ProductName}未填写颜色`);
          return;
        }
        if (ProfitLossModelDts[i].UseProcess && ProfitLossModelDts[i].PropertyId === 0) {
          this.$message.error(`存货${ProfitLossModelDts[i].ProductName}未填写属性`);
          return;
        }
        if(this.data.Type){
          if(ProfitLossModelDts[i].Quantity < 0){
            this.$message.error(`存货${ProfitLossModelDts[i].ProductName}溢损数量需要大于0`);
            return;
          }
        }else{
          if(ProfitLossModelDts[i].Quantity > 0){
            this.$message.error(`存货${ProfitLossModelDts[i].ProductName}溢损数量需要小于0`);
            return;
          }
        }
        // if(ProfitLossModelDts[i].Quantity === 0 || ProfitLossModelDts[i].InPrice === 0 || ProfitLossModelDts[i].OutPrice === 0){
        //    this.$message({type: 'warning', message: '存货数量或价格不能为0'})
        //   return
        // }
      }
      
      let o = {
        ProfitLossModelDts,
        ...this.data,
      };
      // console.log("🚀 ~ save ~ o:", o)
      // return
      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.ProfitLossId = res.Data;
          }
          if(type !== 1){
            this.$message.success(res.Msg);
          }
          this.isSave = true;

          this.api.info(this.data.ProfitLossId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              if(type === 1){
                this.reView1()
              }else{
                this.editInit(res.Data, "keep");
              }
             
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.isSave = false;
      }
    },
    reView1() {
      let id = this.data.ProfitLossId;
      this.api.review(id).then((res) => {
        if (res.Code === 0) {
          var rdata = res.Data;
          this.$nextTick(() => {
            if (rdata.InDocId > 0) {
              this.inDocApi.examine(rdata.InDocId).then();
            }
            if (rdata.OutDocId > 0) {
              this.outDocApi.examine(rdata.OutDocId).then();
            }
          });
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.ProfitLossId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.ProfitLossId;
      this.api.back(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.ProfitLossId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let Id = this.data.ProfitLossId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;

  .text {
    width: 60px;
  }
}

.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.span {
  display: inline-block;
  width: 180px;
}
</style>
